import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { ServiceFulfillmentTypeTag, UnitTag } from "@msuite/ui/tag";
import { getAtomicNumberString } from "@msuite/utils/organizations";
import { getUnitTranslationKey, guardString } from "@msuite/utils/strings";
import type { Enums, Tables } from "@msuite/utils/types";
import { NoteText } from "@/components/notes";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<Required<Tables<"organizationServicesWithFullNumber">>>();

export const columns = [
	columnHelper.accessor((row) => getAtomicNumberString(row.fullNumber), {
		id: "fullNumber",
		header: localized("general.number"),
		cell: (info) => info.getValue(),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("shortText", {
		header: localized("organization.data.short_text"),
		cell: (info) => <strong className="font-medium">{info.getValue()}</strong>,
	}),
	columnHelper.accessor("longText", {
		header: localized("organization.data.long_text"),
		cell: (info) => (
			<NoteText
				note={guardString(info.getValue())}
				withPopover
			/>
		),
		size: 400,
	}),
	columnHelper.accessor((row) => localized(getUnitTranslationKey(row.unit)), {
		id: "unit",
		header: localized("units.unit"),
		cell: (info) => <UnitTag unit={info.row.original.unit as Enums<"unit">} />,
	}),
	columnHelper.accessor("fulfillmentType", {
		header: localized("organization.data.fulfillment_type"),
		cell: (info) => <ServiceFulfillmentTypeTag fulfillmentType={info.getValue()} />,
	}),
	createRowActions(RowActions),
];
